import React from 'react';
import { CenteredSpinner, makeStyles } from 'housecall-ui';

interface Props {
  show: boolean;
  size?: number;
}

const useStyles = makeStyles((theme) => ({
  spinnerWrapper: {
    width: '100%',
    position: 'absolute',
    left: '0',
    top: '0',
    height: '100%',
    backgroundColor: 'rgba(255,255,255,0.7)',
    zIndex: theme.zIndex.snackbar + 1,
    overflow: 'hidden',
  },
}));

export const Spinner = ({ show, size }: Props) => {
  const { spinnerWrapper } = useStyles();
  if (!show) return null;

  return (
    <div className={spinnerWrapper} data-testid="online-booking-spinner">
      <CenteredSpinner spinnerSize={size || 50} />
    </div>
  );
};
